import { render } from "./PopupSyntheticObjectConfiguration.vue?vue&type=template&id=717010af"
import script from "./PopupSyntheticObjectConfiguration.vue?vue&type=script&lang=js"
export * from "./PopupSyntheticObjectConfiguration.vue?vue&type=script&lang=js"

import "./PopupSyntheticObjectConfiguration.vue?vue&type=style&index=0&id=717010af&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__